import * as React from "react";
import { Heading, ListAddIllustration, NonIdealState, Stack, TableView, Text } from "@workflows/ui";
import { useTranslation } from "react-i18next";
import { useAttachmentsFragment } from "~/attachments/hooks/useAttachmentsFragment";
import { AnonymousAttachmentsDelete } from "~/attachments/AnonymousAttachmentsDelete";
import { humanFileSize } from "@workflows/std-js/string";
import { useAnonymousMatter } from "~/matters/AnonymousMatter/hooks/useAnonymousMatter";
interface AttachmentsListProps {
  matterId: string;
  code: string;
  tenantId: string;
  disabled?: boolean;
}
export const AnonymousAttachmentsList = ({
  matterId,
  code,
  tenantId,
  disabled
}: AttachmentsListProps) => {
  const {
    t
  } = useTranslation("ai.workflows.matters", {
    keyPrefix: "AnonymousAttachmentsList"
  });
  const {
    anonymousMatter
  } = useAnonymousMatter(matterId, code, tenantId);
  const attachments = useAttachmentsFragment(anonymousMatter);
  const columns = useColumns(code, matterId, disabled);
  if (attachments.length < 1) {
    return null;
  }
  return <>
      <Heading>{t("heading")}</Heading>
      <TableView initialSort={{
      column: "title",
      order: "ASC"
    }} columns={columns} data={attachments} emptyState={<NonIdealState title={t("noAttachmentsState.title")} header={<ListAddIllustration size="md" />} description={t("noAttachmentsState.description")} />} />
    </>;
};
function useColumns(code: string, refId: string, disabled?: boolean) {
  const {
    t
  } = useTranslation("ai.workflows.matters", {
    keyPrefix: "AnonymousAttachmentsList"
  });
  return React.useMemo(() => [{
    id: "name",
    header: t("cols.title"),
    width: "50%",
    sortable: true,
    render: ({
      value: attachment
    }: any) => <Stack direction={"horizontal"}>
            <Text>{attachment.name}</Text>

            <Text color={"muted"}>
              ({humanFileSize(attachment.contentLength, true)})
            </Text>
          </Stack>
  }, ...(!disabled ? [{
    id: "actions",
    header: t("cols.actions"),
    width: "10%",
    render: ({
      value: attachment
    }: any) => <AnonymousAttachmentsDelete attachment={attachment} code={code} refId={refId} />
  }] : [])], [code, disabled, t, refId]);
}